import React from "react";
import "./GetMusicOnBoomplay.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnBoomplay = () => {

  const steps = [
    "Create your FTTunes account",
    "Upload music & artwork",
    "Deliver music to Boomplay",
    "Get artist profile live",
    "Reach African audiences",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>

        <title>
          Get Your Music on Boomplay | Boomplay Music Distribution | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute your music on Boomplay with FT Tunes. Reach millions of listeners across Africa, grow your fanbase and earn streaming royalties worldwide."
        />

        <meta
          name="keywords"
          content="Boomplay music distribution, upload music to Boomplay, Boomplay for artists, distribute music Africa, FT Tunes distribution"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="FT Tunes" />

        <meta property="og:title" content="Get Your Music on Boomplay | FT Tunes" />

        <meta
          property="og:description"
          content="Upload your music on Boomplay and reach millions of listeners across Africa with FT Tunes distribution."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://www.fttunes.com/get-your-music-on-boomplay"
        />

      </Helmet>

      <div className="boomplay-page">

        {/* HERO */}
        <section className="boomplay-hero">
          <Container>

            <img
              className="boomplay-logo"
              src="/Images/boomplay-logo.png"
              alt="Get Music on Boomplay"
            />

            <h1>Get Your Music on Boomplay</h1>

            <p>
              Get your music on Boomplay and connect with millions of active
              listeners across Africa and global markets. Boomplay is one of the
              fastest-growing music streaming platforms, helping independent
              artists expand their reach, grow fan engagement, and generate
              streaming revenue. With FT Tunes music distribution, your songs
              are delivered professionally with fast approval, high-quality
              audio delivery, and complete ownership control. Release singles,
              EPs, or albums on Boomplay and build a powerful international
              music presence today.
            </p>

            <Button
              className="gradient-btn"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-boomplay"></div>
        </section>

        {/* SHOWCASE */}
        <section className="boomplay-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach Millions of African Listeners</h2>

                <p>
                  Boomplay connects artists with a massive audience across
                  Africa. Upload your music and grow your fanbase in one of the
                  fastest-growing music markets in the world.
                </p>

                <Button
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Distribute Now
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-boomplay.png"
                  alt="get your music on boomplay"
                  className="boomplay-image"
                />
              </Col>

            </Row>
          </Container>
        </section>

        {/* STEPS */}
        <section className="boomplay-steps">
          <Container>

            <h2 className="section-title">
              How It Works
            </h2>

            <Row>
              {steps.map((step,index)=>(
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index+1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>

        {/* BENEFITS */}
        <section className="boomplay-benefits">
          <Container>

            <h2 className="section-title">
              Built For Independent Artists
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Massive Audience</h5>
                  <p>Reach millions of Boomplay users across Africa.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>100% Ownership</h5>
                  <p>You keep full rights to your music.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Earn Royalties</h5>
                  <p>Generate income from streams worldwide.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Artist Growth</h5>
                  <p>Expand your global music presence.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>

        {/* CTA */}
        <section className="boomplay-cta">
          <Container>

            <h2>Start Growing on Boomplay Today</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Upload Your Music
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnBoomplay;  